import { render, staticRenderFns } from "./RequestCommentAdded.vue?vue&type=template&id=7a4fbae6"
import script from "./RequestCommentAdded.vue?vue&type=script&lang=js"
export * from "./RequestCommentAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports